<template>
    <modal v-if="showModal" :max-width="1500" @close="closeModal(false)">
            <div class="modal-box">
                <div>
                    <div class="modal-header" style="border-bottom:0px;padding: 0px;background-color: white">
                        <span>{{ header }}</span>
                        <i class="fa fa-times modal-close-icon" @click="closeModal(false)" />                    
                    </div>
                </div>               
            </div>
            <div class="p-2">
            <textarea id="js-section" rows="38" readonly v-model="data" class="editor border my-1 bg-slate-600" ></textarea>
        </div>
        </modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue";
require('../style.css')

export default {
    components:{Modal},
    props:{
        showModal: { type: Boolean, default: false},
        data:{ type: String, default: ''},
        header:{ type: String, default: ''},
    },
    data(){
        return{}
    },
    methods: {
        closeModal(value){
        this.$emit('close',value, "","")
      } 
    }
  };
</script>
